import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute() {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-caireen-cream">
                <Loader2 className="w-6 h-6 animate-spin text-caireen-orange" />
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/admin/login" replace state={{ from: location }} />;
    }
    return <Outlet />;
}
